import { FC, useCallback } from "react";

import { ArrowDownIcon } from "../icons";

import { SquareButton } from "./buttons/SquareButton";

import { t } from "i18n/i18n";
import { toastErrorMessage } from "utils/alerts";
import { CSVData, downloadCSVFile, formatCSVFilename } from "utils/file";

type DownloadCSVButtonProps = {
  title: string;
  csvData: CSVData | (() => Promise<CSVData>);
  text?: string;
  className?: string;
};

export const DownloadCSVButton: FC<DownloadCSVButtonProps> = ({
  title,
  csvData,
  text,
  className,
}) => {
  const handleClick = useCallback(async () => {
    try {
      const resolvedCsvData = typeof csvData === "object" ? csvData : await csvData();
      downloadCSVFile(resolvedCsvData, formatCSVFilename(title));
    } catch {
      toastErrorMessage(t("assessment_summary_report.export_failed"));
    }
  }, [csvData, title]);

  return (
    <SquareButton
      className={className}
      kind="tertiary"
      size="s"
      title="Download CSV"
      onClick={handleClick}
    >
      {text && <div>{text}</div>}
      <ArrowDownIcon />
    </SquareButton>
  );
};
